<script setup lang="ts">
    import {computed, ref} from 'vue';

    defineProps<{disabled: boolean}>();

    const emit = defineEmits<{
        (event: 'verify', credentials: {orderId: string; emailAddress: string}): void;
    }>();

    const orderId = ref('');
    const emailAddress = ref('');

    const incomplete = computed(() => orderId.value.trim() === '' || emailAddress.value.trim() === '');
</script>

<template>
    <form
        class="panel panel-default panel-body mao-form"
        @submit.prevent="emit('verify', {orderId: orderId.trim(), emailAddress: emailAddress.trim()})">
        <div class="c-panel__heading">Zoek je bestelling op</div>
        <p class="text-muted">Vul je bestelnummer en het e-mailadres van de bestelling in.</p>

        <label class="form-group show">
            Bestelnummer
            <input
                v-model="orderId"
                class="form-control"
                type="text"
                inputmode="numeric"
                maxlength="10"
                autocomplete="off"
                :disabled="disabled" />
        </label>

        <label class="form-group show">
            E-mailadres
            <input
                v-model="emailAddress"
                class="form-control"
                type="email"
                maxlength="254"
                autocomplete="email"
                :disabled="disabled" />
        </label>

        <button
            type="submit"
            class="c-button btn-block"
            :disabled="disabled || incomplete">
            Bestelling zoeken
        </button>
    </form>
</template>
